import { SpacingToken } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import ReviewFormFooter from './ReviewForm'
import ReviewsFooter from './Reviews'

const modalFooterCss = css`
  display: flex;
  gap: var(${SpacingToken.Spacing2});
  justify-content: flex-end;
`

interface Props {
  id: string
  onClose: () => void
  onClick: () => void
  isReviewFormOpen: boolean
}

const RatingModalFooter = ({
  id,
  onClose,
  onClick,
  isReviewFormOpen,
}: Props) => {
  if (isReviewFormOpen) {
    return (
      <div css={modalFooterCss}>
        <ReviewFormFooter id={id} onClick={onClick} onClose={onClose} />
      </div>
    )
  }

  return (
    <div css={modalFooterCss}>
      <ReviewsFooter id={id} onClick={onClick} onClose={onClose} />
    </div>
  )
}

export default RatingModalFooter
